import { httpV2 } from "@/api/index";

/**
 * @summary Obtém as informações dos sinais de um diagnóstico.
 * @param {number} id - Id do diagnóstico.
 * @returns {promise} Promise da chamada da API.
 */
const GetDiagnosticSignals = function(id)
{
	return httpV2.get(`/ParallelMisalignmentGeneratorShaftSettings/${id}/Signals`);
};

export default { GetDiagnosticSignals };
